import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const InvalidPasswordError = () => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="invalid-password-error" severity="error">
            {t('formErrors.invalidPasswordError.tryAgain')}
        </Alert>
    );
};
